module.exports = __webpack_public_path__ + "static/media/work.ab62a156.svg";